module.exports = ".cursor-pointer {\n    cursor: pointer;\n}\n.advanced-search {\n    border-bottom: 1px solid #edf0f4;\n    margin: -0.5em 1.5em 1em 0;\n    padding-bottom: 1em;\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/viagens/deslocamentos/deslocamento-calendar/deslocamento-calendar.component.css
 ** module id = 662
 ** module chunks = 0
 **/